import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState, type FC } from "react";
import type { UUID } from "../../../../../utils/uuid";
import { usePendo } from "../../../../analytics/hooks/use-pendo-watch";

export const FollowUpRecurringUnsupportedDialog: FC<{
  open: boolean;
  onClose: () => void;
  momentId: UUID;
}> = ({ open, onClose, momentId }) => {
  const [interested, setInterested] = useState(false);
  const pendo = usePendo();

  const handleInterested = (): void => {
    setInterested(true);
    pendo?.track("follow-up-recurring-register-interest", { momentId });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Follow-Ups can’t be created for recurring Communications</DialogTitle>
      <DialogContent>
        <Typography>
          Follow-Ups aren’t currently available for recurring Communications. If you’re interested
          in using Follow-Ups on recurring Communications, please let us know.
        </Typography>
        {interested && (
          <Alert severity="success" sx={{ mt: 2 }}>
            Thanks for registering your interest!
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        {!interested && (
          <Button
            data-analytics-id="follow-up-recurring-register-interest-button"
            variant="contained"
            onClick={handleInterested}
          >
            I’m interested
          </Button>
        )}
        <Button
          data-analytics-id="follow-up-recurring-unsupported-dialog-close-button"
          variant="text"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
